import React, { useState, useEffect, useCallback } from 'react';
import splashVideo from '../../assets/dawn_splash_2.mp4';

/**
 * SplashScreen - Dawn branded splash with video.
 * Shows once per session on app load, then fades out.
 * Wraps children — app content is hidden until splash completes.
 */
const SplashScreen = ({ children }) => {
  const [splashDone, setSplashDone] = useState(() => {
    return sessionStorage.getItem('dawn-splash-shown') === 'true';
  });
  const [fadeOut, setFadeOut] = useState(false);

  const completeSplash = useCallback(() => {
    setSplashDone(true);
    sessionStorage.setItem('dawn-splash-shown', 'true');
  }, []);

  const handleVideoEnd = useCallback(() => {
    setFadeOut(true);
    setTimeout(completeSplash, 700);
  }, [completeSplash]);

  useEffect(() => {
    if (splashDone) return;

    // Fallback in case video fails to load or play
    const fallbackTimer = setTimeout(() => {
      setFadeOut(true);
      setTimeout(completeSplash, 700);
    }, 10000);

    return () => clearTimeout(fallbackTimer);
  }, [splashDone, completeSplash]);

  if (splashDone) return children;

  return (
    <div className={`splash-screen ${fadeOut ? 'splash-fade-out' : ''}`}>
      <video
        autoPlay
        muted
        playsInline
        onEnded={handleVideoEnd}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
        }}
      >
        <source src={splashVideo} type="video/mp4" />
      </video>
    </div>
  );
};

export default SplashScreen;
